import { mapGetters } from 'vuex';

export default {
    name: 'dspReview',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp'])
    },
    props: {
        reviewUrl: {
            type: String,
            default: () => {return ''}
        }
    },
    mounted(){
        this.initial();
    },
    methods: {
        initial(){
            $(this.$refs.dspReviews).find('li').each(function(index, item){
                var $this = $(item).find('.desc');

                if($this.prop('scrollHeight') > ($this.prop('clientHeight') + 6)){
                    $(item).find('.reviewlink').show();
                } else{
                    $(item).find('.reviewlink').hide();
                }

            });
        }
    }
};
